<template>
  <div class="bg-brand-light-gray flex flex-col md:py-12">
    <div
      class="
        w-full
        md:max-w-screen-lg
        flex flex-col
        bg-white
        rounded-sm
        shadow
        mx-auto
        py-10
        px-10
      "
    >
      <h2 class="text-2xl py-1">Applicant Warning Message</h2>
      <Line />

      <p class="py-2 font-light">
        On some Rent Application applications, you may see a warning message
        like this displayed at the top of the application form:
      </p>
      <p>
        <img
          class="py-1 w-auto md:w-1/3 h-auto mx-auto"
          src="@/assets/images/applicant-warning-message.png"
        />
      </p>

      <p class="py-2 font-light">
        This is only intended as a precautionary warning and does NOT indicate
        anything about the landlord, property, or property manager. We ask that
        all applicants and property managers communicate closely and take
        reasonable precautions to safeguard information security.
      </p>

      <h2 class="text-2xl py-1">Why Do We Display This Message?</h2>
      <Line />
      <p class="py-2 font-light">
        The vast majority of landlords, property managers, leasing agents, and
        those involved in the residential rental business are honest,
        hardworking, good people doing their best to providing housing for
        tenants and protect their real estate investments by using applications
        as a way to screen for quality tenants.
      </p>

      <p class="py-2 font-light">
        However, there are some people who take advantage of this and post false
        listings, and engage in illicit practices to scam prospective tenants.
        This hurts both applicants and honest real estate professionals,
        landlords, and investors.
      </p>

      <p class="py-2 font-light">
        All major rental sites have exposure to this issue to some degree.
        Please view
        <a
          href="http://www.craigslist.org/about/scams"
          target="_blank"
          class="text-brand-green hover:underline"
        >
          Craigslist's page regarding scams
        </a>
        for some more information.
      </p>

      <h2 class="text-2xl py-1">
        How Can A Landlord or Property Manager Remove This Message?
      </h2>
      <Line />
      <p class="py-2 font-light">Scammers often:</p>
      <ol class="list-decimal px-5">
        <li class="font-light py-1 px-1">
          Use free forms or emails to collect personally identifying data on
          people
        </li>
        <li class="font-light py-1 px-1">
          Fail to be able to meet in person with applicants or verify their
          identity
        </li>
      </ol>
      <Line />
      <p class="py-2 font-light">
        To remove the warning message, as a landlord or property manager with a
        Rent Application account, you can:
      </p>

      <p class="py-3 font-light">
        1. Configure your application form to process screening reports, and
        therefore charge an application fee.
      </p>

      <p class="py-2 font-light">
        Most applicants are less willing to submit an application fee through an
        online site until they have viewed the rental property. As a result,
        scammers are unable to collect information by posting application links
        that require applicants to pay a fee.
      </p>

      <p class="py-3 font-light">2. Verify your identity with Experian</p>

      <p class="py-2 font-light">
        Even if you don't plan to run credit reports, verifying your identity
        through Experian will verify your account, so the warning message will
        no longer be displayed. You should see a yellow Experian banner
        displayed at the top of the page when you log into your account
        dashboard and click on Forms.
      </p>

      <p class="py-2 font-light">
        If you do not see the banner or link to verify with Experian, contact
        <a :mailto="supportEmail" class="text-brand-green">{{
          supportEmail
        }}</a>
        for further assistance.
      </p>
    </div>

    <div
      class="
        w-full
        md:max-w-screen-lg
        flex flex-col
        bg-white
        rounded-sm
        shadow
        mx-auto
        py-10
        px-10
        mt-5
      "
    >
      <h2 class="text-2xl py-1">Applicant Safety Tips</h2>
      <Line />

      <ol class="list-decimal px-5">
        <li class="font-light py-1 px-1">
          If you ARE local: Visit the rental property before applying. This will
          avoid 99% of scam attempts. Being shown the rental property in person
          by the person who gives you the www.rentapplication.net application
          link is the best way to avoid scams.
        </li>
        <li class="font-light py-1 px-1">
          If you are NOT local: Sometimes you may be renting from out of town or
          moving to a new place. If so, work with a reputable agency or a
          contact person with a real estate license of some sort.
        </li>

        <li class="font-light py-1 px-1">
          Avoid situations where you can not verify the identity of the person,
          they are unresponsive to phone requests, or otherwise make it
          difficult to contact them.
        </li>

        <li class="font-light py-1 px-1">
          Do NOT send money for deposits or rent sight unseen, ever.
        </li>

        <li class="font-light py-1 px-1">
          Don't submit information electronically that you wouldn't feel
          comfortable submitting to that person on paper. If you haven't met the
          person face-to-face and haven't viewed the property in person, don't
          submit sensitive information that you wouldn't send to someone you
          don't know.
        </li>
      </ol>
    </div>
  </div>
  <Footer />
</template>
